import actions, { workspaceFormActions, workspaceActions } from './constants';

export const fetchWorkspaceForm = (category, code, intl) => ({
  type: workspaceFormActions.FETCH_WORKSPACE_FORM,
  category,
  code,
  intl,
});

export const showWorkspaceForm = (category, code, result) => ({
  type: workspaceFormActions.SHOW_WORKSPACE_FORM,
  category,
  code,
  result,
});

export const showWorkspaceFormError = (category, code, error) => ({
  type: workspaceFormActions.SHOW_WORKSPACE_FORM_ERROR,
  category,
  code,
  error,
});

export const showWorkspaceRequestReceipt = (name, text) => ({
  type: workspaceFormActions.SHOW_WORKSPACE_REQUEST_RECEIPT,
  name,
  text,
});

export const fetchWorkspaceLocations = (category) => ({
  type: actions.FETCH_WORKSPACE_LOCATIONS,
  category,
});

export const showWorkspaceLocations = (category, results) => ({
  type: actions.SHOW_WORKSPACE_LOCATIONS,
  category,
  results,
});

export const showWorkspaceLocationsError = (category, error) => ({
  type: actions.SHOW_WORKSPACE_LOCATIONS_ERROR,
  category,
  error,
});

export const showWorkspaceFormHealthSuccess = (code) => ({
  type: workspaceFormActions.SHOW_WORKSPACE_FORM_HEALTH_SUCCESS,
  code,
});

export const showWorkspaceFormHealthError = (code, source) => ({
  type: workspaceFormActions.SHOW_WORKSPACE_FORM_HEALTH_ERROR,
  code,
  source,
});

export const requestWorkspaceSuccess = (code, result) => ({
  type: workspaceActions.REQUEST_WORKSPACE_SUCCESS,
  code,
  result,
});

export const closeRequestWorkspace = ({ code }) => ({
  type: workspaceActions.CLOSE_REQUEST_WORKSPACE,
  code,
});

export const requestWorkspaceError = (code, error) => ({
  type: workspaceActions.REQUEST_WORKSPACE_ERROR,
  code,
  error,
});
